import type { ReactNode } from "react";

import { bodyUrl } from "../lib/api.js";

interface HtmlFrameProps {
  folder: string;
  uid: number;
  showImages: boolean;
}

/**
 * De HTML van een bericht is vijandige input. Ze is aan de serverkant al
 * gesaneerd, maar de tweede laag is dit iframe: zonder allow-scripts draait er
 * niets, en zonder allow-same-origin zit het document in een unieke origin en
 * kan het niet bij onze cookies, localStorage of DOM.
 *
 * De prijs daarvan is dat we de inhoudshoogte niet kunnen meten: zonder
 * allow-same-origin is er geen contentDocument, en een postMessage-truc zou
 * allow-scripts vereisen. Automatisch meegroeien kan dus niet zonder de
 * sandbox open te breken. Daarom een vaste hoogte met een eigen scrollbar —
 * dezelfde keuze die Roundcube en Thunderbird maken.
 */
export function HtmlFrame({ folder, uid, showImages }: HtmlFrameProps): ReactNode {
  return (
    <div className="html-frame">
      <iframe
        // Wisselt de afbeeldingskeuze, dan moet het frame echt opnieuw laden en
        // niet alleen zijn src bijwerken.
        key={`${folder}:${uid}:${showImages ? "1" : "0"}`}
        src={bodyUrl(folder, uid, showImages)}
        title="Inhoud van het bericht"
        sandbox="allow-popups allow-popups-to-escape-sandbox"
        referrerPolicy="no-referrer"
        loading="lazy"
      />
    </div>
  );
}
